// extracted by mini-css-extract-plugin
export default {"filtered":"IconsLib_filtered__7Fyzf","normal":"IconsLib_normal__Ml7Na"};